import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Box,
} from "@mui/material";

import { t } from "i18next";
import { useTheme as useMuiTheme } from "@mui/material";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  itemName: string;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  itemName,
}) => {
  const [deleting, setDeleting] = React.useState(false);

  const muiTheme = useMuiTheme();
  const isDarkMode = muiTheme.palette.mode === "dark";
  const themeColors = {
    cardBg: isDarkMode ? "#1e1e1e" : "#ffffff",
    border: isDarkMode ? "rgba(255,255,255,0.12)" : "#e2e8f0",
  };

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error("Failed to delete:", error);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: themeColors.cardBg,
          borderBottom: `1px solid ${themeColors.border}`,
          py: 2,
        }}
      >
        {t("reservations.deleteAsset")} {itemName}
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box
          sx={{
            gap: 2,
            mt: 3,
          }}
        >
          {t("reservations.confirmDeleteAsset", { itemName })}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1.5 }}>
        <Button onClick={onClose} disabled={deleting}>
          {t("common.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={deleting}
        >
          {deleting ? t("reservations.deleting") : t("common.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
